/** Utilitários HTML do composer (e-mail, anotações internas). */

export function stripHtmlToPlain(html, { trim = true } = {}) {
  if (html == null || typeof html !== "string") return "";
  const normalized = html
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/div>/gi, "\n")
    .replace(/<\/p>/gi, "\n");
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = normalized;
  const text = (tempDiv.textContent || tempDiv.innerText || "").replace(/\n{3,}/g, "\n\n");
  return trim ? text.trim() : text;
}

/** Texto plano do composer para menções/transferência (preserva espaços durante a digitação). */
export function composerPlainText(message, { trim = false } = {}) {
  const raw = typeof message === "string" ? message : "";
  if (!raw) return "";
  if (isProbablyHtml(raw)) return stripHtmlToPlain(raw, { trim });
  return trim ? raw.trim() : raw;
}

export function isProbablyHtml(text) {
  if (text == null || typeof text !== "string") return false;
  return /<[a-z][\s\S]*>/i.test(text);
}

export function composerHasTextPayload(message) {
  const raw = typeof message === "string" ? message.trim() : "";
  if (!raw) return false;
  if (isProbablyHtml(raw)) return stripHtmlToPlain(raw).length > 0;
  return true;
}
